import styled from 'styled-components';
import { withLinkUnderlined } from 'app/theme';

export const Text = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.indent.m};
`;

export const InputRow = styled.div`
  & > p {
    text-align: left;
  }
`;

export const Page = styled.form`
  margin: 0 auto;

  ${InputRow},
  button {
    width: 100%;
    max-width: 288px;
    margin: 0 auto;
  }

  button {
    margin-top: ${({ theme }) => theme.indent.l};
  }

  a {
    ${withLinkUnderlined}
  }
`;
